var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-table"},[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.data,"loading":_vm.loading,"footer-props":{ itemsPerPageOptions: [5, 10, 20] },"dense":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }